import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/autoplay";

export default function Brandlogos() {
  const location = useLocation();
  const isGridRoute = location.pathname === "/" || location.pathname === "/brands";

  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBrands = async () => {
      try {
        const res = await axios.get(process.env.REACT_APP_BASE_URL + "/getBrands");
        if (res.status === 200) {
          setBrands(res.data);
        }
      } catch (error) {
        console.error("Error fetching brands:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBrands();
  }, []);

  return (
    <section className="brand-sec py-10 w-full">
      <div className={ "px-0"  }>
        <div className="flex items-center gap-4 mb-8 px-4 container mx-auto px-4">
          <h2 className="text-3xl font-light">Brendet</h2>
          <div className="flex-1 h-px bg-gray-200" />
        </div>

        <div className={`bg-white rounded-lg ${isGridRoute ? "p-3" : "py-6"}`}>
          {isGridRoute ? (
            <ul className="grid gap-6 grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 items-center place-items-center">
              {brands.map((logo, idx) => (
                <li key={idx} className="w-full flex justify-center max-w-[200px]">
                  <a href={`/brands/${logo.slug}`} aria-label={logo.brand} className="group w-full  rounded-lg flex items-center justify-center">
                    <div style={{height: 96}} className="w-full h-full flex items-center justify-center bg-gray-50 rounded-md overflow-hidden shadow-sm transition transform grayscale group-hover:grayscale-0 group-hover:scale-105 group-hover:-translate-y-2 group-hover:shadow-2xl footer-brand-image">
                      <img
                        src={logo.brandImage}
                        alt={logo.brand}
                        className={`mx-auto object-contain max-h-16 md:max-h-24 ${logo.brand === 'EA7' ? 'resize-brand' : ''}`}
                        loading="lazy"
                        width="200"
                        height="80"
                      />
                    </div>
                  </a>
                </li>
              ))}
            </ul>
          ) : (
            <Swiper
              modules={[Autoplay]}
              autoplay={{
                delay: 0,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
                stopOnLastSlide: false,
              }}
              speed={3000}
              loop={true}
              spaceBetween={30}
              slidesPerView={2}
              breakpoints={{
                640: { slidesPerView: 3 },
                768: { slidesPerView: 4 },
                1024: { slidesPerView: 6 },
                1280: { slidesPerView: 7 },
              }}
              className="!px-4"
            >
              {brands.map((logo, idx) => (
                <SwiperSlide key={idx}>
                  <a href={`/brands/${logo.slug}`} aria-label={logo.brand} className="group w-full p-4 flex items-center justify-center">
                    <div className="w-full h-full flex items-center justify-center bg-gray-50 rounded-md overflow-hidden shadow-sm transition transform grayscale group-hover:grayscale-0 group-hover:scale-105 group-hover:-translate-y-2 group-hover:shadow-2xl footer-brand-image">
                      <img
                        src={logo.brandImage}
                        alt={logo.brand}
                        className="mx-auto object-contain max-h-16 md:max-h-24"
                        loading="lazy"
                        width="200"
                        height="80"
                      />
                    </div>
                  </a>
                </SwiperSlide>
              ))}
            </Swiper>
          )}
        </div>
      </div>
    </section>
  );
}
